import React from 'react';
import Router from './Router';

function ProviderManager() {
  return <Router />;
}

export default ProviderManager;
